import React from 'react';

interface FlagProps {
    icon: string;
    name: string;
}

const Flag: React.FC<FlagProps> = ({ icon, name }) => {
    return (
       <div className="max-w-[128px] max-[576px]:max-w-[92px]">
            <div className="flex justify-center items-center w-[128px] h-[128px] max-[576px]:w-[92px] max-[576px]:h-[92px] bg-contain bg-center bg-no-repeat rounded-full shadow-[0_10px_20px_0_#00000026] bg-white" 
            >

            <img className='w-[120px]  h-fit max-[576px]:w-full' src={icon} alt="emblem" />
            </div> 
            <p className="text-center mt-4 text-black uppercase font-bold leading-[125%]">
                {name}
            </p> 
       </div>
    )
}

export default Flag